import {TabsTransformationStartsNow} from './TabsTransformationStartsNow';
export default TabsTransformationStartsNow;
